export const cookies_string = 'HOTELWEB';
export const server_ip=''

//http://localhost:5001
//https://21whitfieldseaview.com/
//new prod: 'http://43.198.113.132'
//prod: 'http://43.198.18.229'
//uat: 'http://16.163.143.195'
